/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateProductCategoryRequest,
    EditProductCategoryRequest,
    IdResponse,
    LinkGoogleProductCategoriesRequest,
} from '../models';

export interface ProductCategoryApiControllerCreateProductCategoryRequest {
    createProductCategoryRequest: CreateProductCategoryRequest;
}

export interface ProductCategoryApiControllerDeleteProductCategoryRequest {
    id: string;
}

export interface ProductCategoryApiControllerDisableProductCategoryRequest {
    id: string;
}

export interface ProductCategoryApiControllerEditProductCategoryRequest {
    id: string;
    editProductCategoryRequest: EditProductCategoryRequest;
}

export interface ProductCategoryApiControllerEnableProductCategoryRequest {
    id: string;
}

export interface ProductCategoryApiControllerLinkGoogleProductCategoriesRequest {
    id: string;
    linkGoogleProductCategoriesRequest: LinkGoogleProductCategoriesRequest;
}

/**
 * 
 */
export class ProductCategoriesApi extends runtime.BaseAPI {

    /**
     */
    async productCategoryApiControllerCreateProductCategoryRaw(requestParameters: ProductCategoryApiControllerCreateProductCategoryRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.createProductCategoryRequest === null || requestParameters.createProductCategoryRequest === undefined) {
            throw new runtime.RequiredError('createProductCategoryRequest','Required parameter requestParameters.createProductCategoryRequest was null or undefined when calling productCategoryApiControllerCreateProductCategory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/product-categories`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createProductCategoryRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async productCategoryApiControllerCreateProductCategory(requestParameters: ProductCategoryApiControllerCreateProductCategoryRequest): Promise<IdResponse> {
        const response = await this.productCategoryApiControllerCreateProductCategoryRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async productCategoryApiControllerDeleteProductCategoryRaw(requestParameters: ProductCategoryApiControllerDeleteProductCategoryRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling productCategoryApiControllerDeleteProductCategory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/product-categories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async productCategoryApiControllerDeleteProductCategory(requestParameters: ProductCategoryApiControllerDeleteProductCategoryRequest): Promise<void> {
        await this.productCategoryApiControllerDeleteProductCategoryRaw(requestParameters);
    }

    /**
     */
    async productCategoryApiControllerDisableProductCategoryRaw(requestParameters: ProductCategoryApiControllerDisableProductCategoryRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling productCategoryApiControllerDisableProductCategory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/product-categories/{id}:disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async productCategoryApiControllerDisableProductCategory(requestParameters: ProductCategoryApiControllerDisableProductCategoryRequest): Promise<void> {
        await this.productCategoryApiControllerDisableProductCategoryRaw(requestParameters);
    }

    /**
     */
    async productCategoryApiControllerEditProductCategoryRaw(requestParameters: ProductCategoryApiControllerEditProductCategoryRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling productCategoryApiControllerEditProductCategory.');
        }

        if (requestParameters.editProductCategoryRequest === null || requestParameters.editProductCategoryRequest === undefined) {
            throw new runtime.RequiredError('editProductCategoryRequest','Required parameter requestParameters.editProductCategoryRequest was null or undefined when calling productCategoryApiControllerEditProductCategory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/product-categories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.editProductCategoryRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async productCategoryApiControllerEditProductCategory(requestParameters: ProductCategoryApiControllerEditProductCategoryRequest): Promise<void> {
        await this.productCategoryApiControllerEditProductCategoryRaw(requestParameters);
    }

    /**
     */
    async productCategoryApiControllerEnableProductCategoryRaw(requestParameters: ProductCategoryApiControllerEnableProductCategoryRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling productCategoryApiControllerEnableProductCategory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/product-categories/{id}:enable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async productCategoryApiControllerEnableProductCategory(requestParameters: ProductCategoryApiControllerEnableProductCategoryRequest): Promise<void> {
        await this.productCategoryApiControllerEnableProductCategoryRaw(requestParameters);
    }

    /**
     */
    async productCategoryApiControllerLinkGoogleProductCategoriesRaw(requestParameters: ProductCategoryApiControllerLinkGoogleProductCategoriesRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling productCategoryApiControllerLinkGoogleProductCategories.');
        }

        if (requestParameters.linkGoogleProductCategoriesRequest === null || requestParameters.linkGoogleProductCategoriesRequest === undefined) {
            throw new runtime.RequiredError('linkGoogleProductCategoriesRequest','Required parameter requestParameters.linkGoogleProductCategoriesRequest was null or undefined when calling productCategoryApiControllerLinkGoogleProductCategories.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/product-categories/{id}:linkGoogleProductCategories`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.linkGoogleProductCategoriesRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async productCategoryApiControllerLinkGoogleProductCategories(requestParameters: ProductCategoryApiControllerLinkGoogleProductCategoriesRequest): Promise<void> {
        await this.productCategoryApiControllerLinkGoogleProductCategoriesRaw(requestParameters);
    }

}
